export default __webpack_public_path__ + "static/media/SharePizza_12.29154aee.png";